import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DataSessionStorage{

    constructor(){}

    saveFilterHome(data : any){
        sessionStorage.setItem('filterHomeI', JSON.stringify(data));
    }

    getFilterHome(){
        return JSON.parse(sessionStorage.getItem('filterHomeI'));
    }

    deleteFilterHome(){
        sessionStorage.removeItem('filterHomeI');
    }
}